export default __webpack_public_path__ + "static/help_05_02_2-92a178b7bc6695d5b7a4007cdc8bfa1d.png";